import React from "react";

const SvgSubtract = props => (
  <svg viewBox="0 0 24 24" {...props}>
    <path d="M1.5 13.5h21a1.5 1.5 0 000-3h-21a1.5 1.5 0 000 3z" />
  </svg>
);

export default SvgSubtract;
